"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFacebookShareUrl = getFacebookShareUrl;
var assert_1 = require("../utils/assert/assert");
var url_1 = require("../utils/url/url");
function getOrigin(url) {
    var a = document.createElement('a');
    a.setAttribute('href', url);
    var port = a.port, protocol = a.protocol, hostname = a.hostname;
    var urlPort = (port === '80' && protocol === 'http:') || (port === '443' && protocol === 'https:') || !port ? '' : ":".concat(port);
    return "".concat(protocol, "//").concat(hostname).concat(urlPort);
}
function getRedirectUrl(settings, albumId, trackId) {
    var baseUrl = settings.baseUrl, pageId = settings.pageId, instanceId = settings.instanceId, compId = settings.compId, tpaApplicationId = settings.tpaApplicationId;
    (0, assert_1.assert)(baseUrl, 'baseUrl is missing');
    (0, assert_1.assert)(pageId, 'pageId is missing');
    (0, assert_1.assert)(instanceId, 'instanceId is missing');
    (0, assert_1.assert)(compId, 'compId is missing');
    (0, assert_1.assert)(albumId, 'albumId is missing');
    var path = (0, url_1.joinUrl)(getOrigin(baseUrl), 'music-share', pageId);
    var params = {
        'instance-id': instanceId,
        'component-id': compId,
        'album-id': albumId,
        'tpa-id': tpaApplicationId,
        'track-id': trackId,
    };
    return "".concat(path, "?").concat((0, url_1.createParam)(params));
}
function getFacebookShareUrl(settings, album, track) {
    var baseUrl = 'https://www.facebook.com/sharer/sharer.php';
    var params = {
        ref: 'site',
        display: 'popup',
        title: 'share it now!',
        u: getRedirectUrl(settings, album.id, track && track.id),
    };
    return "".concat(baseUrl, "?").concat((0, url_1.createParam)(params));
}
//# sourceMappingURL=facebook-social-sharing.js.map